import { getFollowingMonth } from '../getFollowingMonth';

/**
 * Функция получает первые даты 2 ближайших месяца
 * для первичного рендера ячеек. Пример:
 * '2000-01-02' -> ['2000-01-01', '2000-02-01']
 */

export const getFirstTwoMonths = () => {
  const currentDate = new Date();
  const result: string[] = [];

  // ШАГ 1. Получить первую дату текущего месяца
  const currentMonthId = currentDate.getMonth();
  const currentYear = currentDate.getFullYear();
  const handledCurrentMonth =
    currentMonthId + 1 < 10 ? `0${currentMonthId + 1}` : currentMonthId + 1;
  const currentMonthFirstDate = `${currentYear}-${handledCurrentMonth}-01`;
  result.push(currentMonthFirstDate);

  // ШАГ 2. Получить первую дату следующего месяца
  const secondMonthFirstDate = getFollowingMonth(currentMonthFirstDate);
  result.push(secondMonthFirstDate);

  return result;
};
